import React, { useState, useEffect } from 'react';
import {
    Container,
    Typography,
    Box,
    CircularProgress,
    Alert,
} from '@mui/material';
import { format } from 'date-fns';
import { orderService } from '../../services/orderService';
import OrderFilters from '../../components/Orders/OrderFilters';
import OrderStats from '../../components/Orders/OrderStats';
import OrderTable from '../../components/Orders/OrderTable';

const OrdersPage = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [orders, setOrders] = useState([]);
    const [stats, setStats] = useState({ ordersByStatus: [], dailyStats: [] });
    const [total, setTotal] = useState(0);
    const [filters, setFilters] = useState({
        page: 0,
        limit: 10,
        status: '',
        orderId: '',
        startDate: null,
        endDate: null,
    });

    const fetchOrders = async () => {
        try {
            setLoading(true);
            const queryParams = {
                ...filters,
                page: filters.page + 1, // API использует 1-based пагинацию
                startDate: filters.startDate ? format(filters.startDate, 'yyyy-MM-dd') : undefined,
                endDate: filters.endDate ? format(filters.endDate, 'yyyy-MM-dd') : undefined
            };
            const data = await orderService.getAllOrders(queryParams);
            setOrders(data.orders);
            setTotal(data.total);
        } catch (err) {
            setError('Ошибка при загрузке заказов');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchStats = async () => {
        try {
            const { startDate, endDate } = filters;
            const data = await orderService.getOrderStats({ startDate, endDate });
            setStats(data);
        } catch (err) {
            console.error('Ошибка при загрузке статистики:', err);
        }
    };

    useEffect(() => {
        fetchOrders();
        fetchStats();
    }, [filters]);

    const handleFilterChange = (newFilters) => {
        setFilters({ ...filters, ...newFilters, page: 0 });
    };

    const handlePageChange = (newPage) => {
        setFilters({ ...filters, page: newPage });
    };

    const handleLimitChange = (newLimit) => {
        setFilters({ ...filters, limit: newLimit });
    };

    if (error) {
        return (
            <Container maxWidth="lg">
                <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>
            </Container>
        );
    }

    return (
        <Container maxWidth="lg">
            <Typography variant="h4" sx={{ mb: 4 }}>
                Заказы
            </Typography>

            <OrderFilters
                filters={filters}
                onFilterChange={handleFilterChange}
            />

            <OrderStats stats={stats} />

            {loading ? (
                <Box display="flex" justifyContent="center" my={4}>
                    <CircularProgress />
                </Box>
            ) : (
                <OrderTable
                    orders={orders}
                    total={total}
                    page={filters.page}
                    limit={filters.limit}
                    onPageChange={handlePageChange}
                    onLimitChange={handleLimitChange}
                />
            )}
        </Container>
    );
};

export default OrdersPage;
